import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import AsideDescription from './AsideDescription'
import AsideImmersiveItem from './AsideImmersiveItem'

import Close2 from '../../assets/icons/close_2.svg'

const Aside = ({
  attachImmersiveRef,
  closeAside,
  content,
  kind,
  openImmersiveVideoHandler,
  setCurrentImmersiveRef,
  side,
}) => {
  const immersiveRef = useRef([])

  useEffect(() => {
    if (kind === 'immersive') {
      attachImmersiveRef(immersiveRef)
    }
  }, [content])

  return (
    <div
      className={`aside_menu_wrap aside_menu_wrap_${side} ${kind ? 'active_mod' : ''}`}
    >
      <button className="aside_close" onClick={closeAside}>
        <Close2 className="icon icon-close_2 size_mod" />
      </button>
      <div className="aside_in">
        <div className="aside_data" tabIndex="0">
          {kind === 'immersive' &&
            content.map((itemProps, i) => (
              <AsideImmersiveItem
                {...itemProps}
                openImmersiveVideoHandler={openImmersiveVideoHandler}
                key={itemProps.title}
                index={i}
                immersiveRef={immersiveRef}
                setCurrentImmersiveRef={setCurrentImmersiveRef}
              />
            ))}
          {kind === 'description' && <AsideDescription {...content[0]} />}
        </div>
      </div>
    </div>
  )
}

export default Aside

Aside.propTypes = {
  closeAside: PropTypes.func.isRequired,
  content: PropTypes.array.isRequired,
  kind: PropTypes.string.isRequired,
  side: PropTypes.oneOf(['left', 'right']).isRequired,
}

Aside.defaultProps = {
  content: [],
}
